/* src/app/rating/bunny-video/bunny-video.component.scss */
.videobg {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #111;
}
.videobg-width {
  position: absolute;
  width: 100%;
  height: 100%;
  left: -9999px;
  right: -9999px;
  top: 0;
  overflow: hidden;
  margin: auto;
}
.videobg-aspect {
  position: absolute;
  width: 100%;
  height: 0;
  top: -9999px;
  bottom: -9999px;
  margin: auto;
  padding-bottom: 56.25%;
  overflow: hidden;
}
.videobg-make-height {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.videobg-make-height video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
/*# sourceMappingURL=bunny-video.component.css.map */
